
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Eye, EyeOff, ArrowLeft } from 'lucide-react';
import api from '../api/api';

export default function Password() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [tempUser, setTempUser] = useState(null);

  const { setUser, setIsAuthenticated } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('tempUser'));
    if (user) {
      setTempUser(user);
    } else {
      navigate('/');
    }
  }, [navigate]);

  if (!tempUser) return null;

const submit = async (e) => {
  e.preventDefault();
  setError('');

  if (!password) {
    setError('Please enter a password.');
    return;
  }

  try {
    setLoading(true);

    const res = await api.VerifyCustomerPasswordApi(
      tempUser.Vcode,
      password
    );

    const action = res?.VerifyCustomerPasswordApijs?.Table?.[0]?.Action;

    const isSuccess =
      action === 'Login Success' &&
      !!res?.AccessToken &&
      !!res?.RefreshToken &&
      !!(res?.Vid || res?.VerifyCustomerPasswordApijs?.Table?.[0]?.Vid);

    if (isSuccess) {
    const loggedInUser = {
  ...tempUser,
  Vid: res?.Vid || res?.VerifyCustomerPasswordApijs?.Table?.[0]?.Vid || tempUser.Vid,
  UserType: 'Existing User'
};

setUser(loggedInUser);
setIsAuthenticated(true);

localStorage.setItem('user', JSON.stringify(loggedInUser));
sessionStorage.setItem('user', JSON.stringify(loggedInUser));
sessionStorage.setItem('isAuthenticated', 'true');

      localStorage.removeItem('tempUser');
      localStorage.removeItem('nextPage');
      sessionStorage.removeItem('sessionExpiredMessage');

      setMessage('Login successfully');
      setTimeout(() => navigate('/home'), 1000);
    } else {
      setError('Invalid password');
    }
  } catch (err) {
    console.error(err);
    setError('Something went wrong. Try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="flex flex-col justify-center items-center p-4 min-h-[80vh] relative w-full max-w-3xl mx-auto">
      <button
        onClick={() => navigate('/')}
        className="absolute flex items-center gap-2 font-semibold text-gray-600 transition top-4 left-4 hover:text-red-700"
      >
        <ArrowLeft size={20} />
        <span>Back</span>
      </button>
      
      <div className="w-full max-w-sm p-8 mt-10 bg-white shadow-lg rounded-2xl animate-fade-in">
        <div className="flex items-center justify-center p-4">
  <img
    src="/assets/AnnamLogo.PNG"
    alt="Logo"
    className="w-auto h-16 mx-auto"
  />
</div>

        <div className="mb-6 text-center">
          <h1 className="text-3xl font-bold text-gray-800">Enter Password</h1>
          <p className="mt-2 text-gray-600">
            Use your password to continue.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <input
            value={tempUser.Vcode}
            readOnly
            placeholder="Mobile Number"
            className="w-full p-3 text-center bg-gray-100 border rounded-lg"
          />
          <div className="relative">
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              className="w-full p-3 pr-10 text-center border rounded-lg"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute text-gray-500 transform -translate-y-1/2 right-3 top-1/2"
            >
              {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
            </button>
          </div>

          {message && (
            <p className="text-sm text-center text-green-500">{message}</p>
          )}
          {error && (
            <p className="text-sm text-center text-red-500">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 font-bold text-white transition bg-red-500 rounded-lg hover:bg-red-600 disabled:opacity-50"
          >
            {loading ? 'Checking...' : 'Submit'}
          </button>
        </form>

        <p className="mt-4 text-sm text-center text-gray-700">
           <button
             onClick={() => {
               localStorage.setItem('otpSource', 'forgot');
               navigate('/otpverify');
             }}
             className="font-semibold text-red-600"
           >
             Forgot Password?
           </button>
        </p>
      </div>
    </div>
  );
}
